/* Brands directory — category filter group + A–Z rail + instant search (combinable). */
if (!customElements.get('kb-brands')) {
  customElements.define(
    'kb-brands',
    class KbBrands extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-brands-card]'));
        this.tabs = Array.from(this.querySelectorAll('[data-brands-tab]'));
        this.letters = Array.from(this.querySelectorAll('[data-brands-letter]'));
        this.search = this.querySelector('[data-brands-search]');
        this.empty = this.querySelector('[data-brands-empty]');
        this.state = { tab: 'all', letter: 'all', q: '' };

        this.tabs.forEach((t) =>
          t.addEventListener('click', () => {
            this.state.tab = t.dataset.brandsTab;
            this.setActive(this.tabs, t);
            this.apply();
          })
        );
        this.letters.forEach((l) =>
          l.addEventListener('click', () => {
            if (l.getAttribute('aria-disabled') === 'true') return;
            this.state.letter = l.dataset.brandsLetter;
            this.setActive(this.letters, l);
            this.apply();
          })
        );
        if (this.search) {
          this.search.addEventListener('input', () => {
            this.state.q = this.search.value.trim().toLowerCase();
            this.apply();
          });
        }
        this.apply();
      }

      setActive(group, el) {
        group.forEach((g) => {
          const on = g === el;
          g.classList.toggle('is-active', on);
          g.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      cardMatches(card, ignoreLetter) {
        const { tab, letter, q } = this.state;
        if (tab !== 'all' && card.dataset.category !== tab) return false;
        if (!ignoreLetter && letter !== 'all' && card.dataset.letter !== letter) return false;
        if (q && (card.dataset.name || '').indexOf(q) === -1) return false;
        return true;
      }

      apply() {
        // Letters available under the current tab + search (ignoring the active letter)
        const available = new Set(
          this.cards.filter((c) => this.cardMatches(c, true)).map((c) => c.dataset.letter)
        );
        // If the active letter is no longer available, snap back to "All" so the grid never sticks empty
        if (this.state.letter !== 'all' && !available.has(this.state.letter)) {
          this.state.letter = 'all';
          const allBtn = this.letters.find((l) => l.dataset.brandsLetter === 'all');
          if (allBtn) this.setActive(this.letters, allBtn);
        }
        // Visibility
        let shown = 0;
        this.cards.forEach((card) => {
          const visible = this.cardMatches(card, false);
          card.toggleAttribute('hidden', !visible);
          if (visible) shown++;
        });
        // Mark unavailable letters with aria-disabled (kept in tab order, not natively disabled)
        this.letters.forEach((l) => {
          const v = l.dataset.brandsLetter;
          if (v === 'all') return;
          l.setAttribute('aria-disabled', available.has(v) ? 'false' : 'true');
        });
        if (this.empty) this.empty.toggleAttribute('hidden', shown !== 0);
      }
    }
  );
}
